module.exports = __webpack_public_path__ + "static/media/arrow-from-bottom.47287aea.svg";